import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

interface Reasons {
  categoryCode: string;
  categoryDisplayName: string;
  categoryId: number;
  displayReason: string;
  reasonId: number;
  reasonCode: string;
}

interface OnboardingMessagesResponse {
  categoryReasons: Reasons[];
}

export const getReasonMessages = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getReasonMessages: builder.query<OnboardingMessagesResponse, string>({
      query: (preferredLanguage) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;
        return {
          url: "/api/v1/Patient/reasons",
          method: "GET",
          headers,
        };
      },
    }),
  }),
});

export const { useGetReasonMessagesQuery } = getReasonMessages;
